// eslint-disable-next-line
import { Route } from 'vue-router';

import { store } from '../store';

/**
 * updates page transition classes before the route update
 * @param {Route} to
 * @param {Route} from
 * @param {Function} next
 */
export default function(to, from, next) {
  if (!store.state.authStatusKnown) {
    next({
      path: '/',
      query: { redirect: to.fullPath }
    });
    return;
  }

  const { profile } = store.state;
  if (profile) {
    next(`/${profile.role}`);
  } else {
    next();
  }
}
